export default {
  init() {
    $('div.alert.alert-auto-close').not('.alert-important').delay(3000).fadeOut(350);
  }
}
